import { Dialogs } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import DeleteBranchDialog from "../components/deleteBranchDialog/DeleteBranchDialog.js";
export default {
  id: 'rsrc.deleteBranch',
  name: 'Delete Rsrc',
  matches: {
    client: 'GroupScreen',
    use: ['contextMenu'],
    objectType: 'rsrc'
  },
  layout: {
    sort: 'item.deleteBranch',
    sectionName: 'Resource Actions'
  },
  handles: cxt => true,
  appearance: ({
    context
  }) => {
    return {
      name: 'Delete Branch of Rsrcs',
      icon: 'fa fa-fw fa-trash'
    };
  },
  perform: ({
    context
  }) => {
    const {
      clientProps: {
        delegate,
        reloadData
      }
    } = context;
    const onDelete = async branch => {
      await GlobalState.dispatch(delegate.item(branch).delete({
        children: true
      }));
      await reloadData();
    };
    Dialogs.show({
      component: DeleteBranchDialog,
      props: {
        ...context,
        onDelete,
        delegate
      }
    });
  }
};